import { Shield, Truck, CreditCard, Lock } from 'lucide-react';

export function TrustBadges() {
  const badges = [
    {
      icon: Lock,
      label: 'Secure Checkout',
      description: '256-bit SSL encrypted',
    },
    {
      icon: CreditCard,
      label: 'Safe Payment',
      description: 'Paystack & Stripe verified',
    },
    {
      icon: Truck,
      label: 'Fast Delivery',
      description: 'Reliable shipping partners',
    },
    {
      icon: Shield,
      label: 'Buyer Protection',
      description: 'Full refund if not satisfied',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 py-4">
      {badges.map((badge) => (
        <div
          key={badge.label}
          className="flex flex-col items-center text-center p-3 rounded-xl bg-gray-50 border border-gray-100"
        >
          <badge.icon className="h-6 w-6 text-green-600 mb-1.5" />
          <span className="text-xs font-bold text-gray-900">{badge.label}</span>
          <span className="text-[10px] text-gray-500 mt-0.5">{badge.description}</span>
        </div>
      ))}
    </div>
  );
}